define('responsive-gameday/views/Monitor/ViewModels/distributors/VideoContentDistributor',['require','exports','module','message-service/message-service','../../Events/ViewModelUpdateEvents','../../../../helpers/GamePanelViewConfig','jquery'],function(require,exports,module) {
    var MessageService = require("message-service/message-service"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        GamePanelViewConfig = require("../../../../helpers/GamePanelViewConfig"),
        $ = require("jquery");
    var gameData;
    var showViewContent;
    var temp = {visibility:false};
    
    exports.setGameData = function(game) {
        gameData = $.extend({}, game); // type: object
        buildSendDataPack()
        MessageService.on(UpdateEvents.REQUEST_VIDEO_CONTENT_VISIBILITY,function(e) {
          MessageService.publish(UpdateEvents.UPDATE_VIDEO_CONTENT_VISIBILITY,temp);
        });
        
    };
    
    function buildSendDataPack() {
       temp.visibility = (gameData.linescore.liveState !== 'Final') ? false : true;
    }

});


